import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
export function DigitalAccessPolicy() {
  return <section className="py-12 px-4" data-id="element-37" data-mp="f2va3dh3uqdr">
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-2xl mx-auto text-center" data-id="element-38" data-mp="a38wh2xd784f">
        <div className="flex items-center justify-center gap-1.5 mb-2" data-id="element-39" data-mp="14dszylpgc4t">
          <LockIcon className="w-3 h-3 text-gray-600" data-id="element-40" data-mp="3sfxabxc8gdy6" />
          <h2 className="text-[11px] font-medium uppercase tracking-[0.2em] text-gray-600" data-id="element-41" data-mp="3nhlxreujzpc9">
            Digital Access Policy
          </h2>
        </div>

        <p className="text-xs text-gray-600/80 leading-relaxed" data-id="element-42" data-mp="3igy0wcjn8ea4">
          We provide the blueprint; you provide the execution. Because this is a
          digital product delivered instantly,{' '}
          <span className="text-gray-500 font-medium" data-id="element-43" data-mp="39kgx5udlzioe">all sales are final</span>{' '}
          — we don't offer refunds for the same reason a professor doesn't
          refund tuition if you don't study: the value is in the information and
          your commitment to it.
        </p>
      </motion.div>
    </section>;
}